import React, { useEffect, useState } from "react";

const BlogContent = ({ sections }) => {
  const [activeTab, setActiveTab] = useState(sections?.[0]?.keyBlog);

  useEffect(()=>{
    setActiveTab(sections?.[0]?.keyBlog);
  },[sections]);

  const activeSection = sections?.find(
    (section) => section?.keyBlog === activeTab
  );

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 md:px-8 flex flex-col md:flex-row gap-8">
      {/* Left: Navigation Tabs */}
      <div className="w-full md:w-1/4">
        <ul className="space-y-2 sticky top-20">
          <h1 className="text-black-1 font-bold px-3">Contents</h1>
          {sections?.map((section) => (
            <li
              key={section?.keyBlog}
              className={`cursor-pointer px-3 py-2 rounded transition ${
                activeTab === section?.keyBlog
                  ? "bg-red-100 text-red-600 font-semibold"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab(section?.keyBlog)}
            >
              {section?.keyBlog}
            </li>
          ))}
        </ul>
      </div>

      {/* Right: Selected Content */}
      <div className="w-full md:w-3/4 space-y-6">
        <h2 className="text-2xl font-bold text-black-1">
          {activeSection?.keyBlog}
        </h2>
        <p className="text-gray-700 leading-relaxed text-justify whitespace-pre-line">
          {activeSection?.content}
        </p>
      </div>
    </div>
  );
};

export default BlogContent;
